import React, { FC, MouseEvent, useCallback } from "react";
import { ServiceInfoDc } from "@evergis/api";
import { IconButton } from "@evergis/ui";
import { useTranslation } from "react-i18next";

import { createFailedServiceUpdate } from "../../../../evergis/core/layer/createFailedServiceUpdate";
import { isFailedService } from "../../../../interfaces/service";
import { updateLayer, updateTileLayer } from "../../../../resources/layers";
import { useDefaultScaleRange } from "../../../../hooks/style/useDefaultScaleRange";
import { LayerInfo, TableInfo } from "../../../../interfaces/resourceInfo";

interface IRefreshButton {
  layer?: LayerInfo;
  table?: TableInfo;
  refetch: () => Promise<void>;
}
export const RefreshButton: FC<IRefreshButton> = ({ layer, table, refetch }) => {
  const defaultScaleRange = useDefaultScaleRange();
  const [updateLayerMutation] = updateLayer.use();
  const [updateTileLayerMutation] = updateTileLayer.use();
  const { t } = useTranslation("common");

  const refresh = useCallback(
    (e: MouseEvent) => {
      if (e.stopPropagation) {
        e.stopPropagation();
      }

      if (isFailedService(layer as ServiceInfoDc)) {
        if (layer.type === "PostgresTileLayerService") {
          updateTileLayerMutation({
            input: { configuration: createFailedServiceUpdate(layer, table, defaultScaleRange), defaultScaleRange },
          });
        } else {
          updateLayerMutation({
            input: { configuration: createFailedServiceUpdate(layer, table, defaultScaleRange), defaultScaleRange },
          });
        }
      } else {
        refetch();
      }
    },
    [layer, updateTileLayerMutation, table, defaultScaleRange, updateLayerMutation, refetch],
  );

  return <IconButton title={t("actions.refresh")} kind={"refresh"} onClick={refresh} />;
};
